import { notification, Spin } from 'antd';
import { postRequest } from 'api/apiClient';
import { OpButton } from 'components/customAntd/DLS/OpButton/OpButton';
import { IOnSubmitArgs, OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { OpSection } from 'components/customAntd/DLS/OpSection/OpSection';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { useConfirmModal } from 'utils/customHooks/useConfirmModal';
import { LoadingOutlined } from '@ant-design/icons';


interface AltaVideoInstallProps {
    setIsAltaVideoInstallOpen: (open: boolean) => void;
    setIsAltaVideoInstalled: (open: boolean) => void;
}

const AltaVideoInstall: React.FC<AltaVideoInstallProps> = ({ setIsAltaVideoInstallOpen, setIsAltaVideoInstalled }) => {
    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);
    const [form] = OpForm.useForm();
    const confirmModal = useConfirmModal();
    const { t } = useTranslation();
    const [isSubmitting, setSubmitting] = useState(false);

    const handleSubmit = (async ({ values }: IOnSubmitArgs) => {
        setSubmitting(true);
        try {
            let host = values.host.trim();

            if (host.startsWith("https://")) {
                host = host.slice(8);
            } else if (host.startsWith("http://")) {
                host = host.slice(7);
            }

            await postRequest(`/orgs/${orgId}/integrationMsiAltaVideo`, {
                msiAltaVideoUsername: values.email,
                msiAltaVideoPassword: values.password,
                msiAltaVideoApiHost: host,
            });

            notification.success({
                message: t('notification.success'),
                description: t('integration.notification.altaVideoInstallSuccess'),
                placement: 'bottomRight',
            });
            setIsAltaVideoInstalled(true);
            setIsAltaVideoInstallOpen(false);
        } catch (error) {
            notification.error({
                message: t('integration.notification.connectionFailed'),
                description: t('integration.notification.saveError'),
                placement: 'bottomRight'
            });
        } finally {
            setSubmitting(false);
        }
    });

    const handleCancel = () => {
        confirmModal({
            title: t('integration.confirmCancel.title'),
            content: t('integration.confirmCancel.message'),
            okText: t('integration.confirmCancel.ok'),
            cancelText: t('integration.confirmCancel.cancel'),
            onOk: () => {
                setIsAltaVideoInstallOpen(false); // Go back to the main menu
            },
        });
    };

    return (
        <>
            {(isSubmitting) ? (
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
                    <Spin indicator={<LoadingOutlined spin />} />
                </div>
            ) : (
                <><OpSection>
                    <OpForm
                        form={form}
                        onSubmit={handleSubmit}
                        initialValues={{}}
                        defaultButtons={false}
                        hasError={false}
                    >
                        <OpForm.Input
                            name="email"
                            label={t('integration.install.form.email')}
                            rules={[{ required: true, message: t('integration.install.form.emailRequired') }]}
                            placeholder={t('integration.install.form.emailPlaceholder')} />
                        <OpForm.PasswordInput
                            name="password"
                            label={t('integration.install.form.password')}
                            rules={[{ required: true, message: t('integration.install.form.passwordRequired') }]}
                            placeholder={t('integration.install.form.passwordPlaceholder')} />
                        <OpForm.Input
                            name="host"
                            label={t('integration.install.form.host')}
                            rules={[{ required: true, message: t('integration.install.form.hostRequired') }]}
                            placeholder={t('integration.install.form.hostPlaceholder')} />
                    </OpForm>
                </OpSection><OpButton type="primary" htmlType="submit" onClick={form.submit}>
                        {t('integration.install.button.done')}
                    </OpButton><OpButton style={{ margin: '0 8px' }} onClick={handleCancel}>
                        {t('integration.install.button.cancel')}
                    </OpButton></>
            )}
        </>
    );
};

export default AltaVideoInstall;